import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { GuaranteeFormContext } from "@app/guranteeFormWrapper";
import { GuaranteeForm } from "@app/guaranteeForm";
import { useSaveBg } from "./useSaveBg";
import { useLoadBg } from "./useLoadBg";
import { Button, message, Space } from "antd";

interface Props {
  productId: string | null;
}

const footerStyle: React.CSSProperties = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 998,
  background: "#fff",
  padding: "0 16px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderTop: "1px solid #f0f0f0",
  height: 68,
  boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
};

const contentStyle: React.CSSProperties = {
  marginBottom: 48,
}

export default function ProductBgPage({ productId }: Props) {
  if (!productId) return <div className="row muted">Не указан productId</div>;

  const methods = useForm();
  const { loading, bgData } = useLoadBg(productId);
  const { saving, handleSave } = useSaveBg(productId);

  useEffect(() => {
    if (bgData) {
      methods.reset(bgData.components.productBg);
    }
  }, [bgData]);

  const onSave = methods.handleSubmit(async (data) => {
    try {
      const newModel = await handleSave(data);
      methods.reset(newModel.components.productBg);
      BX24.closeApplication();
    } catch (e) {
      message.error("Не удалось сохранить параметры заявки")
      console.error(e);
    }
  });

  const handleClose = () => BX24.closeApplication();

  if (loading) return <div className="row muted">Загрузка данных...</div>;

  return (
    <FormProvider {...methods}>
      <GuaranteeFormContext.Provider
        value={{
          formDisabled: false,
          prefix: "",
          isStartForm: false,
          canEditPurchase: false,
        }}
      >

        <div>
          <div style={contentStyle}>
            <fieldset disabled={false}>
              <GuaranteeForm />
            </fieldset>
          </div>
          <div style={footerStyle}>
            <Space>
              <Button type="primary" size="large" onClick={onSave} loading={saving} style={{ minWidth: 120, justifyContent: "center", }}>
                Сохранить
              </Button>
              <Button size="large" onClick={handleClose} style={{ minWidth: 120, justifyContent: "center", }}>
                Отмена
              </Button>
            </Space>
          </div>
        </div>

      </GuaranteeFormContext.Provider>
    </FormProvider>
  );
}
